import { IOrderAddonItem } from "interfaces";
import { convertCurrency, currencySymbol, formatNumber } from "utills/helpers";

interface AddonProductTableProps {
  data?: IOrderAddonItem[];
  orderCurrency: string;
  rate: number;
}

export const AddonProductTable = ({
  data = [],
  orderCurrency = "",
  rate,
}: AddonProductTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Addon name
              </th>
              <th scope="col" className="th">
                Variant
              </th>
              <th scope="col" className="th">
                Quantity
              </th>
              <th scope="col" className="th">
                Unit price
              </th>
              <th scope="col" className="th">
                Subtotal
              </th>
              <th scope="col" className="th">
                Note
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IOrderAddonItem, index: number) => (
              <tr key={item.id ?? index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {index + 1}
                </td>
                <td className="td">{item.addon_name}</td>
                <td className="td">{item.variant_label || "-"}</td>
                <td className="td" style={{ wordWrap: "break-word" }}>
                  {formatNumber(item.qty ?? 0)}
                </td>
                <td className="td">
                  {currencySymbol()}{" "}
                  {convertCurrency(
                    item.unit_price ?? 0,
                    orderCurrency ?? "",
                    rate
                  )}
                </td>
                <td className="td">
                  {currencySymbol()}{" "}
                  {convertCurrency(
                    item.subtotal ?? 0,
                    orderCurrency ?? "",
                    rate
                  )}
                </td>
                <td className="td">{item.note || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
